import {browserHistory} from 'react-router';
import axios from 'axios';

const baseEndpoint = 'v1/categories';

const CategoryService = {

  deleteCategory( id ) {
    return axios
      .delete( `${baseEndpoint}/${id}` )
  },

  getCategories( params ) {
    return axios
      .get( baseEndpoint, { params } )
  },

  getCategory( id ) {
    return axios
      .get( `${baseEndpoint}/${id}` )
  },

  saveCategory( data ) {
    return axios
      .post( baseEndpoint, data )
  },

  updateCategory( id, data ) {
    return axios
      .put( `${baseEndpoint}/${id}`, data )
  },
};

export default CategoryService;



// WEBPACK FOOTER //
// ./services/CategoryService.js